import { DataGenerator } from './src/DataGenerator';

export { DataGenerator };